import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { connect } from "react-redux";
import { Link, Navigate, useLocation } from "react-router-dom";
import {
  Row,
  Col,
  Badge,
  CardTitle,
  Button,
  Card,
  CardBody,
  Table,
  Alert,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import VWModel from "../../../components/vwModal/vwModal";
import {
  closeChangePasswordModal,
  closeEditUserModal,
  getUserDetails,
  openChangePasswordModal,
  openEditUserModal,
  sendResetPasswordEmail,
  closeTransferDeviceModal,
  openTransferDeviceModal,
  getOrgPreference,
  openChangeOrgPreference,
  closeChangeOrgPreference,
  openDirectChangePasswordModal,
  closeDirectChangePasswordModal,
  clearUserDetailsError,
  clearSendResetPasswordError,
  deleteOthersAccount,
  deleteSelfAccount,
  clearDeleteOthersAccountError,
  clearDeleteSelfAccountError,
} from "../../../store/userdetails/actions";
import {
  CUSTOMER,
  ORGANIZATION_ADMIN,
  SUPER_ADMIN,
  TECHNICIAN
} from "../../../store/users/role.constants";
import ChangePasswordForm from "../ChangePasswordForm";
import Transfer from "../Transfer/Transfer";
import Message from "../../../CommonData/Data/Message";
import VWLoading from "../../../components/vwLoading/vwLoading";
import UITooltip from "../../../CommonData/Data/UITooltip";
import ChangeOrgPreference from "./ChangeOrgPreference";
import DirectChangePassword from "../DirectPasswordChange";
import Swal from "../../../CommonData/Data/Swal";

const UserDetails = (props) => {

  const { currentProfile, errorMessage, resetPasswordError, isChangePasswordModalOpen, isTransferDeviceModalOpen, userDetails, orgPreference, isChangeOrgPreference,
    isDirectChangePasswordModalOpen, deleteSelfAccountErrorMessage, isDeleteSelfAccountPending, isDeleteOtherAccountPending, deleteOtherAccountErrorMessage } = props;
  const { isUserDeletable } = userDetails || {};
  const location = useLocation();
  const queryString = location.pathname;
  const urlParams = queryString && queryString.split("/");
  const id = urlParams && urlParams[3];

  const isCurrentUser = (currentProfile.roles && currentProfile.roles[0] && currentProfile.roles[0].userId) === (userDetails && userDetails.id);
  const isAdmin = currentProfile.roles && currentProfile.roles.length > 0 &&
    (currentProfile.roles[0].roleKey === SUPER_ADMIN || currentProfile.roles[0].roleKey === ORGANIZATION_ADMIN);
  const isOrgAdmin = currentProfile.roles && currentProfile.roles.length > 0 && currentProfile.roles[0].roleKey === ORGANIZATION_ADMIN;
  const isTechnician = currentProfile.roles && currentProfile.roles.length > 0 && (currentProfile.roles[0].roleKey === TECHNICIAN);
  const isCustomer = currentProfile.roles && currentProfile.roles.length > 0 && (currentProfile.roles[0].roleKey === CUSTOMER);
  const isSuperAdmin = currentProfile.roles && currentProfile.roles.length > 0 && (currentProfile.roles[0].roleKey === SUPER_ADMIN);

  const [dropdownOpen, setOpen] = useState(false);
  const [rolesForAdmin, setRolesForAdmin] = useState();
  const [navigate, setNavigate] = useState(false);

  const [swalOptions, setSwalOptions] = useState({
    title: "Are you sure?",
    text: "Do you want to delete this account?",
    icon: "warning",
    buttons: {
      cancel: true,
      confirm: {
        text: "Yes, delete it!",
        value: true,
        visible: true,
        className: "bg-danger",
        closeModal: true,
      },
    },
  });

  useEffect(() => {
    props.getUserDetails(id);
    props.clearUserDetailsError();
    props.clearSendResetPasswordError();
    props.clearDeleteSelfAccountError();
    props.clearDeleteOthersAccountError();
  }, [props.getUserDetails, id]);

  useEffect(() => {
    if (userDetails && userDetails.rolePermissions) {
      const data = userDetails.rolePermissions.split(',');
      const roles = data && data.length > 0 && data.map((role) => {
        if (role === 'dst') {
          return 'Distributor'
        }
        if (role === 'dlr') {
          return 'Dealer'
        }
        if (role === 'sdlr') {
          return 'Sub-Delaer'
        }
        if (role === 'rtr') {
          return 'Retailer'
        }
        else {
          return ''
        }
      })
      setRolesForAdmin(roles)
    }

  }, [userDetails])

  useEffect(() => {
    if (isOrgAdmin && isCurrentUser) {
      props.getOrgPreference();
    }
  }, [isOrgAdmin, isCurrentUser]);
  //----------------------------------------RESET-PASSWORD--------------------------------------------------------------------------------------------
  const handleResetPassword = () => {
    const { userDetails } = props;
    if (userDetails && userDetails.email)
      props.sendResetPasswordEmail(userDetails.email);
  };

  const handleDirectPasswordReset = () => {
    props.openDirectChangePasswordModal();
  };

  const handleDirectPasswordResetClose = () => {
    props.closeDirectChangePasswordModal();
  };
  //----------------------------------------CHANGE-PASSWORD--------------------------------------------------------------------------------------------
  const handleOpenChangePasswordModel = () => {
    props.openChangePasswordModal();
  };

  const handleCloseChangePasswordModel = () => {
    props.closeChangePasswordModal();
  };

  //----------------------------------------TRANSFER-DEVICES--------------------------------------------------------------------------------------------
  const handleOpenTransferModal = () => {
    props.openTransferDeviceModal();
  };

  const handleCloseTransferModal = () => {
    props.closeTransferDeviceModal();
  };

  //----------------------------------------ORG-PREFERENCE--------------------------------------------------------------------------------------------
  const handleOpenChangeOrgPreference = () => {
    props.openChangeOrgPreference();
  };

  const handleCloseChangeOrgPreference = () => {
    props.closeChangeOrgPreference();
  };
  //----------------------------------------DELETE-SELF-ACCOUNT------------------------------------------------------------------------------------------------
  const deleteSelfAccount = (isDelete) => {
    if (isDelete) {
      props.deleteSelfAccount();
    }
  }
  //----------------------------------------DELETE-OTHERS'-ACCOUNT------------------------------------------------------------------------------------------------
  const deleteOthersAccount = (isDelete) => {
    const { userDetails } = props;
    const { id } = userDetails || {};
    if (isDelete) {
      props.deleteOthersAccount(id)
        .then((isDeleted) => {
          if (isDeleted) {
            setNavigate(true);
          }
        })
    }
  }

  return (
    <Fragment>
      {navigate ? <Navigate to="/userlist" /> :
        <div className="page-content">
          <Card>
            <CardTitle className="p-2  mb-0 d-flex justify-content-between align-items-center fs-5 text-dark fw-bold">
              USER DETAILS
              <div className="content-heading">
                <div className="ml-auto">
                  {!(isCustomer || isTechnician) && (
                    ((userDetails && userDetails.isActive) && (userDetails && userDetails.isEnabled) || (isOrgAdmin)) ? <Link
                      type="button"
                      className="mr-1 btn btn-primary btn-sm"
                      to="edit"
                    >
                      <em className="far fa-edit me-2"></em>Edit User
                    </Link> :
                      <UITooltip
                        content="Details cannot be updated for inactive users"
                        id="addDeviceSerialNos"
                        key="addDeviceSerialNos"
                      >
                        <div
                          className="mr-1 btn btn-light-primary btn-sm"
                          style={{ cursor: "no-drop" }}
                        >
                          Edit User
                        </div>
                      </UITooltip>
                  )}
                </div>
              </div>
            </CardTitle>
          </Card>
          {(errorMessage || resetPasswordError) && (
            <Message
              type="danger"
              defaultMessage={errorMessage || resetPasswordError}
              baseClassName="alert"
            />
          )}
          {deleteSelfAccountErrorMessage && (
            <Message
              type="danger"
              defaultMessage={deleteSelfAccountErrorMessage}
              baseClassName="alert"
            />
          )}
          {deleteOtherAccountErrorMessage && (
            <Message
              type="danger"
              defaultMessage={deleteOtherAccountErrorMessage}
              baseClassName="alert"
            />
          )}
          {props.isUserDetailsPending || isDeleteSelfAccountPending || isDeleteOtherAccountPending ?
            <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
              <VWLoading height={40} width={40} />
            </div>
            : (props.userDetails &&
              <Card>
                <CardBody>
                  {
                    (!(userDetails.isActive || userDetails.isEnabled) && !isOrgAdmin) ?
                      <Alert color='danger'>
                        Wait for organization admin approval or check mail for account enable
                      </Alert> : ""
                  }

                  <Row className="justify-content-center">
                    <Col xl="6">
                      <Row>
                        <Col lg={12}>
                          <CardTitle>
                            <h5 className=" text-capitalize">
                              <span>{userDetails.displayName || "NA"}</span>
                            </h5>
                          </CardTitle>
                          <div className="table-responsive">
                            <Table className="table table-bordered table-striped table-hover" >
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>First Name</strong>
                                  </td>
                                  <td>{userDetails.firstName || "NA"}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Last Name</strong>
                                  </td>
                                  <td>{userDetails.lastName || "NA"}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Display Name</strong>
                                  </td>
                                  <td>{userDetails.displayName || "NA"}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Email</strong>
                                  </td>
                                  <td>{userDetails.email || "NA"}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Mobile Number</strong>
                                  </td>
                                  <td>{userDetails.mobileNumber || "NA"}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Managed By</strong>
                                  </td>
                                  <td>{userDetails.managedBy || "NA"}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Current Available Devices</strong>
                                  </td>
                                  <td>{userDetails.devicesCount || "0"}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Organization</strong>
                                  </td>
                                  <td>{userDetails.organisationName || "NA"}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Role</strong>
                                  </td>
                                  <td>
                                    <strong>{userDetails.roleDisplayName || "NA"}</strong>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Activation Status</strong>
                                  </td>
                                  <td>
                                    {userDetails.isEnabled ? (
                                      <Badge color="success">Enabled</Badge>
                                    ) : (
                                      <Badge color="danger">Disabled</Badge>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Account Status</strong>
                                  </td>
                                  <td>
                                    {userDetails.isActive ? (
                                      <Badge color="success">Active</Badge>
                                    ) : (
                                      <Badge color="danger">Inactive</Badge>
                                    )}
                                  </td>
                                </tr>
                                {
                                  ((isSuperAdmin || isCurrentUser) && (userDetails.roleKey === 'OrgAdmin')) &&
                                  <tr>
                                    <td>
                                      <strong> Allowed Roles To Be Create</strong>
                                    </td>
                                    <td>
                                      {(rolesForAdmin && rolesForAdmin.length) > 0 ?
                                        rolesForAdmin.map((role) => (
                                          <Badge color='info' className='me-1'>{role}</Badge>
                                        ))
                                        : 'NA'
                                      }
                                    </td>
                                  </tr>
                                }
                              </tbody>
                            </Table>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl="6">
                      <Row>
                        <Col lg={12}>
                          <Fragment>
                            <h5>ADDRESS</h5>
                            <small className="text-muted subheader text-sm">
                              We will use this address for all official communications.
                            </small>
                            <div className="table-responsive mt-2">
                              <Table className="table table-bordered table-striped table-hover" size='sm'>
                                <tbody>
                                  <tr>
                                    <td>
                                      <strong>Address Line1</strong>
                                    </td>
                                    <td>{userDetails.addressLine1 || "NA"}</td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <strong>Address Line2</strong>
                                    </td>
                                    <td>{userDetails.addressLine2 || "NA"}</td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <strong>State</strong>
                                    </td>
                                    <td>{userDetails.state || "NA"}</td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <strong>District</strong>
                                    </td>
                                    <td>{userDetails.district || "NA"}</td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <strong>Town</strong>
                                    </td>
                                    <td>{userDetails.town || "NA"}</td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <strong>Zone</strong>
                                    </td>
                                    <td>{userDetails.zone || "NA"}</td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <strong>Zip</strong>
                                    </td>
                                    <td>{userDetails.zip || "NA"}</td>
                                  </tr>
                                </tbody>
                              </Table>
                            </div>
                          </Fragment>
                        </Col>
                      </Row>
                      {/* {userDetails && userDetails.roleKe && ( */}
                      <Row>
                        <Col lg={12}>
                          {isCurrentUser ? (
                            <Fragment>
                              {isOrgAdmin &&
                                <div>
                                  <h5>ORGANIZATION PREFERENCE</h5>
                                  <Table className="table table-bordered table-striped table-hover w-75">
                                    <tbody>
                                      <tr>
                                        <th>Approve New Customer Status</th>
                                        <td>{orgPreference && orgPreference.approveNewCustomer ? (
                                          <Badge color="success">Enabled</Badge>
                                        ) : (
                                          <Badge color="danger">Disabled</Badge>
                                        )}</td>
                                      </tr>
                                      <tr>
                                        <th>Allow Customer Self Registration Status</th>
                                        <td>{orgPreference && orgPreference.allowCustomerSelfRegistration ? (
                                          <Badge color="success">Enabled</Badge>
                                        ) : (
                                          <Badge color="danger">Disabled</Badge>
                                        )}</td>
                                      </tr>
                                      <tr>
                                        <th>Email Notification To Customer Status</th>
                                        <td>{orgPreference && orgPreference.enableUserMailNotification ? (
                                          <Badge color="success">Enabled</Badge>
                                        ) : (
                                          <Badge color="danger">Disabled</Badge>
                                        )}</td>
                                      </tr>
                                      <tr>
                                        <th> Device Return Without Approval Status</th>
                                        <td>{orgPreference && orgPreference.isReturnApproval ? (
                                          <Badge color="success">Enabled</Badge>
                                        ) : (
                                          <Badge color="danger">Disabled</Badge>
                                        )}</td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                  <div className="mt-2">
                                    <Button
                                      className="btn-oval"
                                      size='sm'
                                      color='success'
                                      onClick={handleOpenChangeOrgPreference}
                                    >Change Preference
                                    </Button>
                                  </div>
                                </div>}
                              <div className="mt-4">
                                <h5>CHANGE PASSWORD</h5>
                                <small className="text-muted subheader text-sm">
                                  In order to change a password you will need to provide your current password.
                                </small>
                                <div className="mt-2">
                                  <Button
                                    className="btn-oval"
                                    size='sm'
                                    color='danger'
                                    onClick={handleOpenChangePasswordModel}
                                  >Change Password
                                  </Button>
                                </div>
                              </div>
                            </Fragment>
                          ) :
                            isOrgAdmin &&
                            (<Fragment>
                              <h5>RESET PASSWORD</h5>
                              <small className="text-muted subheader text-sm">
                                By selecting the reset password button, an email will be sent to this user with password reset instructions.
                              </small>
                              <div className="mt-2 mb-4">
                                <ButtonDropdown toggle={() => { setOpen(!dropdownOpen) }}
                                  isOpen={dropdownOpen}>
                                  <Button
                                    className="btn-oval"
                                    color='danger'
                                    size='sm'
                                    onClick={() => { setOpen(!dropdownOpen) }}
                                  >Reset Password
                                  </Button>
                                  <DropdownToggle
                                    color='danger'
                                    split
                                    className='px-2'
                                  >
                                    {dropdownOpen ? <i class="fas fa-caret-down" />
                                      : <i class="fas fa-caret-up" />
                                    }
                                  </DropdownToggle>
                                  <DropdownMenu>
                                    <DropdownItem onClick={handleResetPassword}>
                                      Reset via Email
                                    </DropdownItem>
                                    <DropdownItem onClick={handleDirectPasswordReset}>
                                      Reset Directly
                                    </DropdownItem>
                                  </DropdownMenu>
                                </ButtonDropdown>
                              </div>
                            </Fragment>
                            )}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          {(isCustomer && isCurrentUser) &&
                            <div className="mt-2">
                              <h5>DELETE ACCOUNT</h5>
                              <small className="text-muted subheader text-sm">
                                You can delete your account. Once delete your account , your devices are returned to the retailer.
                              </small>
                              <div className="mt-2 mb-4">
                                <div className="btn btn-sm btn-danger">
                                  <Swal
                                    options={swalOptions}
                                    callback={deleteSelfAccount}
                                  >
                                    Delete Account
                                  </Swal>
                                </div>
                              </div>
                            </div>
                          }
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          {(isAdmin && !isCurrentUser && isUserDeletable && (userDetails && userDetails.roleKey !== "Manufacturer")) &&
                            <div className="mt-2">
                              <h5>DELETE ACCOUNT</h5>
                              <small className="text-muted subheader text-sm">
                                You can delete user account if he doesn't have any devices and subordinates.
                              </small>
                              <div className="mt-2 mb-4">
                                <div className="btn btn-sm btn-danger">
                                  <Swal
                                    options={swalOptions}
                                    callback={deleteOthersAccount}
                                  >
                                    Delete Account
                                  </Swal>
                                </div>
                              </div>
                            </div>
                          }
                        </Col>
                      </Row>
                      {/* )} */}
                      {(isAdmin && !isCurrentUser) && (
                        <Row>
                          <Col lg={12}>
                            <Fragment>
                              <h5>TRANSFER</h5>
                              <small className="text-muted subheader text-sm">
                                You can tranfer the devices or users of this user to another user.
                                You can transfer all the devices/users or selected devices/users from the given option.
                              </small>
                              <div className="mt-2">
                                <Button
                                  className="btn-oval"
                                  color='primary'
                                  size="sm"
                                  onClick={handleOpenTransferModal}
                                >Transfer
                                </Button>
                              </div>
                            </Fragment>
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            )}
        </div>}
      <VWModel
        header="CHANGE PASSWORD"
        isOpen={isChangePasswordModalOpen}
        handleClose={handleCloseChangePasswordModel}
      >
        <ChangePasswordForm
          handleClose={handleCloseChangePasswordModel}
        />
      </VWModel>
      <VWModel
        header="RESET PASSWORD"
        isOpen={isDirectChangePasswordModalOpen}
        handleClose={handleDirectPasswordResetClose}
      >
        <DirectChangePassword
          userId={userDetails && userDetails.id}
          handleClose={handleDirectPasswordResetClose}
        />
      </VWModel>
      <VWModel
        header="CHANGE ORGANIZATION PREFERENCE"
        isOpen={isChangeOrgPreference}
        handleClose={handleCloseChangeOrgPreference}
      >
        <ChangeOrgPreference
          handleClose={handleCloseChangeOrgPreference}
          orgPreferenceDetails={orgPreference}
          userId={id}
        />
      </VWModel>
      <VWModel
        header="TRANSFER"
        isOpen={isTransferDeviceModalOpen}
        handleClose={handleCloseTransferModal}
      >
        <Transfer
          userId={userDetails && userDetails.id}
          organisationId={userDetails && userDetails.orgId}
          handleClose={handleCloseTransferModal}
        />
      </VWModel>
    </Fragment >

  );
}

const mapStateToProps = (state) => ({
  //----------------------------------------USER-DETAILS-------------------------------------------------------------------------------------
  userDetails: state.userdetails.userDetails,
  isUserDetailsPending: state.userdetails.isUserDetailsPending,
  errorMessage: state.userdetails.userDetailsError,
  currentProfile: state.login.currentProfile,
  isEditUserModalOpen: state.userdetails.isEditUserModalOpen,
  //----------------------------------------RESET-PASSWORD-----------------------------------------------------------------------------------
  isResetPasswordPending: state.userdetails.isResetPasswordPending,
  isDirectChangePasswordModalOpen: state.userdetails.isDirectChangePasswordModalOpen,
  resetPasswordError: state.userdetails.resetPasswordError,
  //----------------------------------------CHANGE-PASSWORD----------------------------------------------------------------------------------
  isChangePasswordModalOpen: state.userdetails.isChangePasswordModalOpen,
  //----------------------------------------TRANSFER-DEVICES---------------------------------------------------------------------------------
  isTransferDeviceModalOpen: state.userdetails.isTransferDeviceModalOpen,
  //----------------------------------------ORG-PREFERENCE-----------------------------------------------------------------------------------
  orgPreference: state.userdetails.orgPreference,
  isChangeOrgPreference: state.userdetails.isChangeOrgPreference,
  //----------------------------------------DELETE-SELF-ACCOUNT------------------------------------------------------------------------------
  isDeleteSelfAccountPending: state.userdetails.isDeleteSelfAccountPending,
  deleteSelfAccountErrorMessage: state.userdetails.deleteSelfAccountErrorMessage,
  //----------------------------------------DELETE-OTHERS'-ACCOUNT---------------------------------------------------------------------------
  isDeleteOtherAccountPending: state.userdetails.isDeleteOtherAccountPending,
  deleteOtherAccountErrorMessage: state.userdetails.deleteOtherAccountErrorMessage,
});

const mapDispatchToProps = (dispatch) => ({
  //----------------------------------------USER-DETAILS-------------------------------------------------------------------------------------
  getUserDetails: (userId) => dispatch(getUserDetails(userId)),
  closeEditUserModal: () => dispatch(closeEditUserModal()),
  openEditUserModal: () => dispatch(openEditUserModal()),
  clearUserDetailsError: () => dispatch(clearUserDetailsError()),
  //----------------------------------------RESET-PASSWORD-----------------------------------------------------------------------------------
  sendResetPasswordEmail: (email) => dispatch(sendResetPasswordEmail(email)),
  clearSendResetPasswordError: () => dispatch(clearSendResetPasswordError()),
  openDirectChangePasswordModal: () => dispatch(openDirectChangePasswordModal()),
  closeDirectChangePasswordModal: () => dispatch(closeDirectChangePasswordModal()),
  //----------------------------------------CHANGE-PASSWORD----------------------------------------------------------------------------------
  openChangePasswordModal: () => dispatch(openChangePasswordModal()),
  closeChangePasswordModal: () => dispatch(closeChangePasswordModal()),
  //----------------------------------------TRANSFER-DEVICES---------------------------------------------------------------------------------
  closeTransferDeviceModal: () => dispatch(closeTransferDeviceModal()),
  openTransferDeviceModal: () => dispatch(openTransferDeviceModal()),
  //----------------------------------------ORG-PREFERENCE-----------------------------------------------------------------------------------
  getOrgPreference: () => dispatch(getOrgPreference()),
  openChangeOrgPreference: () => dispatch(openChangeOrgPreference()),
  closeChangeOrgPreference: () => dispatch(closeChangeOrgPreference()),
  //----------------------------------------DELETE-SELF-ACCOUNT------------------------------------------------------------------------------
  deleteSelfAccount: () => dispatch(deleteSelfAccount()),
  clearDeleteSelfAccountError: () => dispatch(clearDeleteSelfAccountError()),
  //----------------------------------------DELETE-OTHERS'-ACCOUNT---------------------------------------------------------------------------
  deleteOthersAccount: (selectedUserId) => dispatch(deleteOthersAccount(selectedUserId)),
  clearDeleteOthersAccountError: () => dispatch(clearDeleteOthersAccountError()),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserDetails);
